const firebaseErrorMessages: { [key: string]: string } = {
  'auth/user-not-found': 'User not registered',
  'auth/wrong-password': 'Wrong User/Password',
  'auth/email-already-exists':
    'The email address is already in use by another account.',
  '6': 'Entity already exists in the database.',
  'auth/credential-already-in-use':
    'Microsoft account is already linked to another user',
  'auth/provider-already-linked':
    'Microsoft account is already linked to the current user',
  'auth/requires-recent-login': 'Please log in again and try again',
};

export default firebaseErrorMessages;
